import Wix from '../services/wix-sdk-polyfill';

export const openSettingsDialog = () => () => {
  Wix.Preview.openSettingsDialog();
};



// WEBPACK FOOTER //
// ./app/actions/open-settings-dialog.js